import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  textAreaRoot: {
    "& .MuiInputBase-root": {
      boxShadow: " 4px 4px 4px 0px #0C38911A",
      border: `1px solid ${theme.palette.events.grayShade1}`,
      "&::placeholder": {
        color: "black",
      },
    },
  },
}));
